export default __webpack_public_path__ + "static/media/shirt.55480863.svg";